import {
  PhoneQuestion,
  Question,
  Questions,
} from '../../classes/question'

export const getEmergencyContactQuestions = (
  customQuestions: Questions,
): Questions => [
  new Question({
    label: 'patient-intake.emergency-contact-section.field-contact-name',
    key: 'emergencyContactName',
    flex: '100',
  }),

  new PhoneQuestion({
    label: 'patient-intake.emergency-contact-section.field-phone-number',
    key: 'emergencyContactPhoneNumber',
    flex: '100',
  }),

  ...customQuestions,
]
